import AppConstants from "../constants/AppConstants.js";
import { getDisplayColor } from "../app2components/base/ColorPicker.jsx";
import DesignThemeStore from "../stores/DesignThemeStore.js";

const { TRANSPARENT, DEFAULT_PALETTE } = AppConstants;

/**
 * Resolves a background-color string (which may be a palette reference or
 * the transparent keyword) into an rgba CSS string suitable for the
 * DotLottie player.
 *
 * @param {string|undefined} backgroundColorString - Raw color value from content.
 * @returns {string|undefined} An rgba colour string, or undefined when transparent/empty.
 */
export const resolveBackgroundColor = (backgroundColorString) => {
  if (!backgroundColorString || backgroundColorString === TRANSPARENT)
    return undefined;
  const designColors = DesignThemeStore.getColors();
  const palette = designColors?.toJS() ?? DEFAULT_PALETTE;
  return getDisplayColor(palette, backgroundColorString).toRgbString();
};

export default { resolveBackgroundColor };
